module.exports = __webpack_public_path__ + "assets/cis_member_logo.a242bba236677d42272753977e9911d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cis_member_logo.png
// module id = 92
// module chunks = 0